import React from 'react';
import IconButton from '@mui/material/IconButton';
import { OutlinedIcons } from '@marageti/z4-lib';
import Tooltip from '@mui/material/Tooltip';

const { OutlinedArchiveIcon } = OutlinedIcons;

const ClearFromQueueButton = ({ clearFromQueue }: { clearFromQueue: (e: React.MouseEvent<HTMLButtonElement>) => void }) => (
  <Tooltip title="Clear from Queue">
    <IconButton disableRipple onClick={clearFromQueue}>
      <OutlinedArchiveIcon color="primary" />
    </IconButton>
  </Tooltip>
);

export default ClearFromQueueButton;
